import { render, staticRenderFns } from "./jljk.vue?vue&type=template&id=3f211b5a&scoped=true"
import script from "./jljk.vue?vue&type=script&lang=js"
export * from "./jljk.vue?vue&type=script&lang=js"
import style0 from "./jljk.vue?vue&type=style&index=0&id=3f211b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f211b5a",
  null
  
)

export default component.exports